/**
 * GA4 Analytics helper — wraps window.gtag calls safely.
 * GA4 ID is injected at build time via REACT_APP_GA4_ID.
 */

const GA_ID = process.env.REACT_APP_GA4_ID;

function gtag() {
  if (window.gtag) {
    window.gtag.apply(null, arguments);
  }
}

/** Track a page view (call on every route change) */
export function trackPageView(path, title) {
  if (!GA_ID) return;
  gtag('config', GA_ID, {
    page_path: path,
    page_title: title,
  });
}

/** Track a custom event */
export function trackEvent(eventName, params = {}) {
  if (!GA_ID) return;
  gtag('event', eventName, params);
}

// ---- Convenience wrappers for required events ----

export const analytics = {
  signupClick: () => trackEvent('signup_click'),
  signupSuccess: (method = 'email') => trackEvent('signup_success', { method }),
  loginSuccess: (method = 'email') => trackEvent('login_success', { method }),
  cvCheckStarted: () => trackEvent('cv_check_started'),
  cvCheckCompleted: (score) => trackEvent('cv_check_completed', { score }),
  whatsappClick: (context) => trackEvent('whatsapp_click', { context }),
  salarySearch: (query) => trackEvent('salary_search', { search_term: query }),
  pricingClick: (product) => trackEvent('pricing_click', { product }),
  payNowClick: (product) => trackEvent('pay_now_click', { product }),
};
